import { Module } from 'vuex';
import { Store } from '../store';

export enum Theme {
  dark = 'dark',
  light = 'light',
}

export enum SubBrand {
  usa = 'usa',
  eq = 'eq',
  none = 'none',
}

export interface State {
  theme: Theme;
  subBrand: SubBrand;
}

export interface Getters {
  propsTheme: Theme;
  subBrand: SubBrand;
}
export type Actions = 'setTheme';
export const themes: Module<State, Store> = {
  namespaced: true,
  state: {
    theme: Theme.light,
    subBrand: SubBrand.eq,
  },
  getters: {
    propsTheme: (state): Theme => {
      return state.theme;
    },
    subBrand: (state): SubBrand => {
      return state.subBrand;
    },
  },
  actions: {
    setTheme: ({ commit }, theme: string) => {
      if (Object.values<string>(Theme).includes(theme)) {
        commit('setTheme', theme);
      }
    },
    setSubBrand: ({ commit }, subBrand: string) => {
      if (Object.values<string>(SubBrand).includes(subBrand)) {
        commit('setSubBrand', subBrand);
      }
    },
  },
  mutations: {
    setTheme: (state, theme: Theme) => {
      state.theme = theme;
    },
    setSubBrand: (state, subBrand: SubBrand) => {
      state.subBrand = subBrand;
    },
  },
};
